import * as React from "react";
import axios from "axios";
import { BarChart } from "@mui/x-charts/BarChart";

export default function SpeedComparisonChart({ restaurant = "K071002" }) {
  const [chartData, setChartData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
 const restaurantId = sessionStorage?.getItem("store_id") || "Null";
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `/server/dashboard-functions/average-company-performance/${restaurantId}`
        );

        if (res.data.success) {
          const rawData = res.data.data;

          setChartData({
            labels: rawData.labels,
            series: [
              {
                label: "SOS(O)",
                data: rawData.totalEventOrderDuration,
                color: "#C5411B",
              },
              {
                label: "SOS(W)",
                data: rawData.totalWindowDuration,
                color: "#ff7043",
              },
              rawData.totalEventTotalDuration && {
                label: "SOS(O + W)",
                data: rawData.totalEventTotalDuration,
                color: "#4CAF50",
              },
            ].filter(Boolean), // removes undefined if totalEventTotalDuration doesn't exist
          });
        } else {
          setError("No data available");
        }
      } catch (err) {
        console.error("Error fetching chart data:", err);
        setError("Error fetching chart data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [restaurant]);
const Loader = () => (
    <div className="flex justify-center items-center h-full min-h-[300px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-[#E57320]  border-solid"></div>
    </div>
);
 
  if (loading) return <Loader />;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <div className="mb-4">
        <p className="text-2xl text-gray-800">Average Speed Comparison</p>
      </div>

      {chartData && (
        <BarChart
          height={400}
          series={chartData.series}
          xAxis={[
            {
              scaleType: "band",
              data: chartData.labels,
              label: "Date",
            },
          ]}
          yAxis={[
            {
              label: "Duration per Transaction (ms)",
              valueFormatter: (value) => `${value} ms`,
            },
          ]}
          legend={{
            direction: "row",
            position: { vertical: "top", horizontal: "middle" },
          }}
          grid={{ horizontal: true }}
        />
      )}
    </div>
  );
}
